import { ItemList } from 'orm'

class ProductList extends ItemList {
    getEntityKey() {
        return "contact/product"
    }
}

export const contactProductList = new ProductList("contact_product__default")
